import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getFormValues, destroy } from 'redux-form';
import { withRouter } from 'react-router';

import * as actions from './state/actions';

import { Filter, Main } from 'Containers';
import { USER_ACCESS_ROLE_FORM } from 'Common/FormEnum';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { toastSuccess, toastErrorFromCatch } from 'Common/ToastHelper';
import { loadData, loadDataByRoleId, postData } from './api/Request';
import Form from './Form';
import { formatGroupData, convertFormValuesForAPI } from './helpers/';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { getAccessInfo } from 'Common/Security/state/actions';
import 'PageStyles/userroleaccess/index.less';

class UserRoleAccessContainer extends Component {
  state = {
    activeIndex: 0,
  };

  componentDidMount() {
    const { setPageData } = this.props;

    loadData().then(data => {
      const [pagesByRole, roles] = data;

      setPageData({
        groups: formatGroupData(pagesByRole),
        roles: roles,
        data: pagesByRole,
      });
    });
  }

  componentWillMount() {
    this.props.dispatch(destroy(USER_ACCESS_ROLE_FORM));
  }

  componentDidUpdate() {
    const {
      formValues = {},
      roleId,
      loading,
      setLoading,
      setGroups,
      setRoleId,
    } = this.props;
    const { roleId: formRoleId } = formValues;

    if (!loading && roleId && formRoleId && formRoleId !== roleId) {
      setLoading(true);

      loadDataByRoleId(formRoleId).then(data => {
        const [pagesByRole] = data;
        setRoleId(formRoleId);
        setGroups({
          groups: formatGroupData(pagesByRole),
          data: pagesByRole,
        });
        setLoading(false);
        this.setState({
          activeIndex: 0,
        });
      });
    }
  }

  saveForm = () => {
    const {
      _data,
      setSaving,
      clearSaving,
      formValues,
      setGroups,
      getAccessInfo,
    } = this.props;
    const formData = convertFormValuesForAPI(_data, formValues);
    setSaving();
    postData(formData)
      .then(data => {
        toastSuccess(data[0]);
        setGroups({
          groups: formatGroupData(formData.accessInfoValues),
          data: formData.accessInfoValues,
        });
        getAccessInfo();
        clearSaving();
      })
      .catch(error => {
        clearSaving();
        toastErrorFromCatch(error);
      });
  };

  setActiveIndex = index => {
    const { activeIndex } = this.state;

    this.setState({
      activeIndex: activeIndex !== index ? index : -1,
    });
  };

  getMainProps = () => {
    const { isReadOnly } = this.props;

    return {
      toolbox: {
        isReadOnly,
        formName: USER_ACCESS_ROLE_FORM,
        shown: true,
      },
    };
  };

  render() {
    const { setActiveIndex, saveForm } = this;
    const { activeIndex } = this.state;
    const {
      loading,
      groups,
      roles,
      roleId,
      formValues,
      dispatch,
      saving,
      _data,
    } = this.props;

    if (loading)
      return <LoadingPage message={saving ? 'Saving...' : 'Loading...'} />;

    return (
      <div className="user-role-access--wrapper">
        <Filter title="User Role Access" />
        <Main {...this.getMainProps()}>
          <Form
            activeIndex={activeIndex}
            dispatch={dispatch}
            formValues={formValues}
            rawData={_data}
            groups={groups}
            loading={loading}
            roles={roles}
            roleId={roleId}
            setActiveIndex={setActiveIndex}
            onSubmit={saveForm}
          />
        </Main>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty()(state));

  return {
    ...state.UserRoleAccessState,
    formValues: getFormValues(USER_ACCESS_ROLE_FORM)(state),
  };
};

const mapDispatchToProps = {
  ...actions,
  getAccessInfo,
  dispatch: dispatch => dispatch,
};

export const UserRoleAccess = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserRoleAccessContainer)
);



// WEBPACK FOOTER //
// ./src/pages/userroleaccess/UserRoleAccess.js